export default "__VITE_ASSET__Dqfj3unP__"